import { ajax } from "./ajax";

//1、获取学生学习进度
export const reqlearningProgress = (paramets) =>
  ajax(`/effect/jxEffect/progressList`, paramets);

//2、获取活动参与率
export const reqActivityParticipation = (paramets) =>
  ajax(`/homepage/teachingHomepage/participationRankList`, paramets);

//3、获取活动组织次数
export const reqActivityTime = (paramets) =>
  ajax(`/effect/jxEffect/activityOrganizationList`, paramets);

//4、获取考勤预警
export const reqAttendanceWarning = (paramets) =>
  ajax(`/effect/jxEffect/checkingList`, paramets);

//5、获取预习预警
export const reqPrepareWarning = (paramets) =>
  ajax(`/effect/jxEffect/prepareList`, paramets);

//6、获取作业预警
export const reqJobWarning = (paramets) =>
  ajax(`/effect/jxEffect/jobList`, paramets);

//7、获取活动预警
export const reqActivityWarning = (paramets) =>
  ajax(`/effect/jxEffect/activityList`, paramets);

//8、获取学生过程性评价
export const reqEvaluateList = (paramets) =>
  ajax(`/effect/jxEffect/evaluateList`, paramets);

//9、获取教学明细表
export const reqteachDetail = (paramets) =>
  ajax(`/effect/jxEffect/teachingList`, paramets);

//9、获取教学明细表
export const reqheadInformation = (paramets) =>
  ajax(`/effect/jxEffect/headInformation`, paramets);

//10、获取测验情况
export const reqTestCondition = (paramets) =>
  ajax(`/effect/stuPortrait/classTestRate`, paramets);

//11、获取过程性评价
export const reqEvaluateCondition = (paramets) =>
  ajax(`/effect/stuPortrait/evaluationScore`, paramets);

//12、获取作业情况
export const reqJobCondition = (paramets) =>
  ajax(`/effect/stuPortrait/homeworkTestRate`, paramets);

//13、获取学生基本信息
export const reqStuInfo = (paramets) =>
  ajax(`/effect/stuPortrait/getTeachShowStuInformation`, paramets);

//14、获取学生考勤情况
export const reqStuSignCondition = (paramets) =>
  ajax(`/effect/stuPortrait/getStuSignDetailByCourse`, paramets);

//15、获取学预习情况
export const reqStuPrepareCondition = (paramets) =>
  ajax(`/previewTaskStudent/queryPreviewTaskStudentAll`, paramets);

//1、获取学生学习进度
export const reqlearningProgressWarning = (paramets) =>
  ajax(`/effect/jxEffect/progressList`, paramets);
